var _path, _path2;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgCellphone(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 136,
    height: 136,
    viewBox: "0 0 136 136",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M51.6981 31.7708C47.4368 31.7708 43.7279 35.4797 43.7279 39.7411L43.7279 95.5384C43.7293 97.6518 44.5694 99.6783 46.0638 101.173C47.5582 102.667 49.5847 103.507 51.6981 103.509L83.5848 103.509C85.7154 103.509 87.7164 102.68 89.2214 101.175C90.7264 99.6701 91.555 97.6691 91.555 95.5384L91.555 39.7411C91.555 37.6104 90.7264 35.6094 89.2214 34.1044C87.7164 32.5994 85.7154 31.7708 83.5848 31.7708L51.6981 31.7708ZM83.5848 95.5384L51.6981 95.5384L51.6981 39.7411L83.5848 39.741L83.5848 95.5384Z",
    fill: "#DA0067"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M70.457 87.3677C72.0135 85.8111 72.0135 83.2875 70.457 81.731C68.9004 80.1745 66.3768 80.1745 64.8203 81.731C63.2638 83.2875 63.2638 85.8111 64.8203 87.3677C66.3768 88.9242 68.9004 88.9242 70.457 87.3677Z",
    fill: "#DA0067"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCellphone);
export default __webpack_public_path__ + "static/media/cellphone.dd06b68442beaab23300586cb19078b8.svg";
export { ForwardRef as ReactComponent };